export const LeftArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7461 12.0004C20.7461 12.4146 20.4103 12.7504 19.9961 12.7504L5.80699 12.7504L11.193 18.1364C11.4859 18.4293 11.4859 18.9042 11.193 19.1971C10.9002 19.49 10.4253 19.49 10.1324 19.1971L3.48329 12.548C3.47737 12.5424 3.47151 12.5368 3.46572 12.531C3.31879 12.3841 3.24557 12.1913 3.24605 11.9988C3.24639 11.8073 3.31962 11.6159 3.46572 11.4698C3.47151 11.464 3.47736 11.4583 3.48328 11.4528L10.1324 4.80365C10.4253 4.51076 10.9002 4.51076 11.193 4.80365C11.4859 5.09655 11.4859 5.57142 11.193 5.86431L5.80699 11.2504L19.9961 11.2504C20.4103 11.2504 20.7461 11.5862 20.7461 12.0004Z"
        fill="currentColor"
      />
    </svg>
  );
};
